import axios from "axios";
import _isNil from "lodash/isNil";
import {
  DOMAIN,
  DOMAIN_FILE,
  DOMAIN_WORD,
  DOMAIN_COMMON,
  API_VERSION,
  QLVB_DOMAIN,
  DOMAIN_API_HSLT,
} from "@/constants/constants";
import moment from "moment";
import _isEmpty from "lodash/isEmpty";
import {
  getValueFromStorageByKey,
  LOCAL_STORAGE_KEY,
} from "@/utils/localStorage";
import store from "@/store";

export function buildQueries(params, acceptNull = false) {
  if (_isNil(params) && !acceptNull) {
    params = {};
  }
  let requestString = "";
  Object.keys(params).forEach((key) => {
    if ((!_isNil(params[key]) || acceptNull) && params[key] !== "") {
      requestString += `${key}=${params[key]}&`;
    }
  });
  return requestString;
}

export const HTTP = axios.create({
  baseURL: `${DOMAIN}${API_VERSION}`,
  headers: getHTTPHeader(),
});

export const HTTP_FILE = axios.create({
  baseURL: `${DOMAIN_FILE}${API_VERSION}`,
  headers: getHTTPHeader(),
});

export const HTTP_QLVB = axios.create({
  baseURL: `${QLVB_DOMAIN}${API_VERSION}`,
  headers: getHTTPHeader(),
});

export const HTTP_COMMON = axios.create({
  baseURL: `${DOMAIN_COMMON}${API_VERSION}`,
  headers: getHTTPCommonHeader(),
});

export const HTTP_WORD = axios.create({
  baseURL: `${DOMAIN_WORD}${API_VERSION}`,
  headers: getHTTPHeader(),
});

export const HTTP_SCAN = axios.create({
  baseURL: "http://192.168.50.20:3013",
});

export const HTTP_BLOB = axios.create({
  baseURL: `${DOMAIN}${API_VERSION}`,
  headers: getHTTPHeader(),
  responseType: "blob",
});

export const HTTP_HSLT = axios.create({
  baseURL: `${DOMAIN_API_HSLT}${API_VERSION}`,
  headers: getHTTPHeader(),
});

function getHTTPHeader() {
  if (!_isEmpty(getValueFromStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN))) {
    return {
      Token: getValueFromStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN),
      "Access-Control-Allow-Origin": "*",
      IsMobile: false,
      Accept: "application/json, text/plain, */*",
    };
  }
}

function getHTTPCommonHeader() {
  if (!_isEmpty(getValueFromStorageByKey(LOCAL_STORAGE_KEY.ACCESS_TOKEN))) {
    return {
      Authorization: `Bearer ${getValueFromStorageByKey(
        LOCAL_STORAGE_KEY.ACCESS_TOKEN
      )}`,
      "Access-Control-Allow-Origin": "*",
      IsMobile: false,
    };
  }
  return {
    "Access-Control-Allow-Origin": "*",
    IsMobile: false,
  };
}

export let asyncLoading = false;

HTTP.interceptors.request.use(
  (config) => {
    let data = config.data;
    for (let property in data) {
      if (Object.prototype.toString.call(data[property]) === "[object Date]") {
        config.data[property] = `${moment(data[property]).format(
          "YYYY-MM-DD"
        )}T00:00:00.000Z`;
      }
    }
    asyncLoading = config.asyncLoading;
    if (asyncLoading) store.commit("common/SET_LOADING_SUBMIT", true);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  (response) => {
    let data = response.data.data;
    for (let property in data) {
      if (moment(data[property], moment.ISO_8601, true).isValid()) {
        response.data.data[property] = new Date(data[property]);
      }
    }
    store.commit("common/SET_LOADING_SUBMIT", false);
    return response;
  },
  (error) => {
    store.commit("common/SET_LOADING_SUBMIT", false);
    return Promise.reject(error);
  }
);
